import { styled } from '@mui/material/styles';
import { ImgBox } from 'views/common/components';

export const StyledImgBox = styled(ImgBox)(({ theme }) => ({
  '&.IBimgbox': {
    [theme.breakpoints.down('xl')]: {
      height: theme.typography.pxToRem(272),
    },
    [theme.breakpoints.down('lg')]: {
      height: theme.typography.pxToRem(155),
    },
    [theme.breakpoints.down('md')]: {
      height: theme.typography.pxToRem(81),
    },
  },
}));
